module.exports = __webpack_public_path__ + "img/michael.f2f6b0af.jpg";